export const SHARED_ZONE_NEW = {
  PAGE_SLUG: 'new22',
  RANSOM_SERVICE_SLUG: 'exit-ransom',
  BEELINE_OFFICE_SERVICE_SLUG: 'office-beeline',
  TRADE_IN_SERVICE_SLUG: 'trade-in',
};
